import React, { useEffect, useMemo, useState } from 'react';
import { useApi } from '../../../hooks/useApi';
import logger from '../../../utils/logger';
import './AdminNotificationCatalog.css';

const CHANNEL_LABEL = { inapp: 'В сервисе', email: 'Почта', telegram: 'Telegram' };
const LEVEL_LABEL = { info: 'Информация', success: 'Успех', warning: 'Внимание', error: 'Ошибка' };

function AdminNotificationCatalog() {
  const { request } = useApi();
  const [events, setEvents] = useState(null);
  const [error, setError] = useState('');
  const [query, setQuery] = useState('');

  useEffect(() => {
    request('/api/v1/admin/notification-catalog', {})
      .then((data) => setEvents(data?.events || []))
      .catch((err) => { logger.error(err); setError('Не удалось загрузить каталог.'); });
  }, [request]);

  const groups = useMemo(() => {
    const needle = query.trim().toLowerCase();
    const result = [];
    (events || []).forEach((event) => {
      if (needle && !`${event.label} ${event.key} ${event.recipient} ${event.trigger}`.toLowerCase().includes(needle)) return;
      let group = result.find((item) => item.category === event.category);
      if (!group) {
        group = { category: event.category, label: event.category_label, items: [] };
        result.push(group);
      }
      group.items.push(event);
    });
    return result;
  }, [events, query]);

  return (
    <div className="admin-page ncat">
      <h1>Каталог уведомлений</h1>
      <p className="ncat__lead">
        Какие уведомления бывают, кому и когда они приходят, по каким порогам, и в какие каналы идут по умолчанию.
        Пользователь может включать и отключать каналы по каждому событию в колокольчике; обязательные отключить нельзя.
        Каталог собирается из кода, поэтому всегда актуален.
      </p>
      <input
        className="ncat__search"
        type="search"
        placeholder="Поиск по названию, получателю, условию"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />
      {error && <p role="alert" className="ncat__error">{error}</p>}
      {events === null && !error && <p className="ncat__lead">Загружаем…</p>}
      {groups.map((group) => (
        <section key={group.category} className="ncat__group">
          <h2>{group.label} <span className="ncat__count">{group.items.length}</span></h2>
          <div className="ncat__table-wrap">
            <table className="ncat__table">
              <thead>
                <tr>
                  <th>Событие</th>
                  <th>Кому</th>
                  <th>Когда срабатывает</th>
                  <th>Каналы по умолчанию</th>
                </tr>
              </thead>
              <tbody>
                {group.items.map((event) => (
                  <tr key={event.key}>
                    <td>
                      <strong>{event.label}</strong>
                      <div className="ncat__key">{event.key}</div>
                      <div className="ncat__meta">
                        <span className={`ncat__level ncat__level--${event.level}`}>{LEVEL_LABEL[event.level] || event.level}</span>
                        {event.mandatory && <span className="ncat__flag">обязательное</span>}
                      </div>
                    </td>
                    <td>{event.recipient}</td>
                    <td>
                      {event.trigger}
                      {event.collapse_seconds > 0 && (
                        <div className="ncat__meta">Повторы схлопываются в одно: {Math.round(event.collapse_seconds / 3600) >= 1 ? `${Math.round(event.collapse_seconds / 3600)} ч` : `${Math.round(event.collapse_seconds / 60)} мин`}</div>
                      )}
                      <details className="ncat__example">
                        <summary>Пример текста</summary>
                        <div><strong>{event.title}</strong></div>
                        <div>{event.message}</div>
                      </details>
                    </td>
                    <td>
                      <div className="ncat__channels">
                        {['inapp', 'email', 'telegram'].map((channel) => (
                          <span key={channel} className={`ncat__channel${event.channels.includes(channel) ? ' is-on' : ''}`}>
                            {CHANNEL_LABEL[channel]}
                          </span>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      ))}
      {events && groups.length === 0 && <p className="ncat__lead">Ничего не найдено.</p>}
    </div>
  );
}

export default AdminNotificationCatalog;
